import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { entities } from '../../constants';
import Title from '../Title';
import { Box, Button, Dialog, DialogContent, DialogTitle, EntityLabelGroup, EntityLabel, Label, TextField, Typography, InfoPanel, SectionTitle, Divider } from '@otcmarketsgroup/otcm-ui-lib';

const PreviousAdded = ({ listTitle, items, max = 5, handleSelect }) => {
  const [renderList, setRenderList] = useState(items && items.slice(0, max));
  const showMore = items.length > max && renderList.length <= max;

  return <>
    <Box>
      <Title title={listTitle} type='h3' />
    </Box>
    <EntityLabelGroup>
      {renderList.map((item, i) => {
        const title = (!item.firstName && !item.lastName) ? entities.NO_NAME : `${item.firstName} ${item.lastName}`;
        return (
          <EntityLabel
            key={i}
            title={title}
            subtitle='Select'
            isComplete
            onEntityClick={() => handleSelect(item)} />
        );
      })}
    </EntityLabelGroup>
    {showMore && <Button
      variant='outlined'
      fullWidth
      onClick={() => setRenderList(items)}>
      Show More Individuals...
    </Button>}
  </>;
};

PreviousAdded.propTypes = {
  listTitle: PropTypes.string,
  items: PropTypes.array,
  max: PropTypes.number,
  handleSelect: PropTypes.func
};

export default PreviousAdded;
